import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

const availableModalState = ['none', 'writable'] as const;
export type ModalState = (typeof availableModalState)[number];

type InitialState = {
  modalState: ModalState;
};

const initialState: InitialState = {
  modalState: 'none',
};

export const generateOperationSlice = createSlice({
  name: 'generateOperationSlice',
  initialState,
  reducers: {
    setGenerateOperationModalState: (state, { payload }: PayloadAction<ModalState>) => {
      state.modalState = payload;
    },
    closeGenerateOperationModal: (state) => {
      state.modalState = 'none';
    },
  },
  selectors: {
    selectGenerateOperationModalState: (state) => state.modalState,
  },
});

export const { closeGenerateOperationModal, setGenerateOperationModalState } =
  generateOperationSlice.actions;
export const { selectGenerateOperationModalState } = generateOperationSlice.selectors;
